/**
 * Customer statistics carousel: Swiper
 */
import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';

(function() {
    const sections = document.querySelectorAll('[data-js-customer-statistics]');
    if (!sections.length) return;

    sections.forEach((section) => {
        const swiperEl = section.querySelector('.customer-statistics-swiper');
        const prevBtn = section.querySelector('.customer-statistics-prev');
        const nextBtn = section.querySelector('.customer-statistics-next');

        if (!swiperEl || !prevBtn || !nextBtn) return;

        const slides = swiperEl.querySelectorAll('.swiper-slide');
        if (slides.length <= 1) {
            // Single slide: hide arrows, no swiper needed
            prevBtn.style.display = 'none';
            nextBtn.style.display = 'none';
            return;
        }


        const _swiper = new Swiper(swiperEl, {
            modules: [Navigation],
            loop: true,
            slidesPerView: 1.1,
            spaceBetween: 16,
            breakpoints: {
                768: {
                    slidesPerView: 2.25,
                    spaceBetween: 16,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                1440: {
                    slidesPerView: 4,
                    spaceBetween: 16,
                },
            },
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            observer: true,
            observeParents: true,
        });
    });
})();

